import { GridOptions, RowNode } from 'ag-grid';
import swal, { SweetAlertOptions, SweetAlertResult, SweetAlertType } from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { constant } from '../app.constants';
import { AutoAssignMessages, IAutoAssignStatus, IAutoAssignSummary } from 'app/core/interfaces/auto-assign.interface';
import { IUnifiedAddress, IUnifiedDate, IUnifiedName, IUnifiedPhone } from 'app/core/interfaces/unified-background-check.interface';

export const EMPTY_VALUE = '—';

/**
 * @param min
 * @param max
 */
export function numberRandom(min: number, max: number): number {
  return Math.round(Math.random() * (max - min) + min);
}

export function getDataUser() {
  let user = window.localStorage.getItem('currentUser');

  if (user) {
    return user = JSON.parse(user);
  } else {
    return {
      fullname: '',
      isClient: '',
      reenterpassword: '',
      roleid: '',
      token: '',
      username: '',
      userprofileid: '',
      usertypeid: '',
    };
  }

}

function _inObj(object: any, param: string) {
  try {
    return object[param];
  } catch (error) {
    return undefined;
  }
}

export function inObject(object: any, params: string) {
  try {
    const attrs = params.split('.');
    let tmp = object;
    if (tmp !== undefined) {
      attrs.forEach(element => {
        if (tmp !== undefined) {
          tmp = _inObj(tmp, element);
        } else {
          tmp = undefined;
        }
      });
    }
    return typeof tmp === 'undefined' ? undefined : typeof tmp;
  } catch (error) {
    return undefined;
  }

}

export function exists(obj: any, path: string, returnObject?: boolean) {
  try {
    const params = path.split('.');
    let lo: any;
    params.forEach(function (param) {
      lo = (lo ? lo : obj)[param];
    });
    return returnObject ? lo : lo === undefined ? undefined : typeof lo;
  } catch (error) {
    return undefined;
  }

}
export function secondsToMins(sec_num) {
  const hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  const seconds = sec_num - (hours * 3600) - (minutes * 60);
  return `${Math.ceil(minutes) < 10 ? '0' + Math.ceil(minutes) : Math.ceil(minutes)}:` +
    `${Math.ceil(seconds) < 10 ? '0' + Math.ceil(seconds) : Math.ceil(seconds)}`;
}

export function isDate(value: any): boolean {
  return value instanceof Date && !isNaN(value.valueOf());
  // return !/Invalid|NaN/.test(new Date(obj).toString());
}


export function normalize(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;';
  const to = 'aaaaaeeeeeiiiiooooouuuunc------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '_') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
}

export function modalSwal(title: string, type: any, text: string) {
  return swal({
    title: title,
    type: type,
    text: text,
  });
}

export const ValidateTotalMilesLyft = (totalMiles: number): boolean => {
  return totalMiles >= constant.TOTAL_MILES_ALERT_LYFT;
};

export const excludedProviderAlertOptions = (speedCode: string): SweetAlertOptions => ({
  title: 'Warning',
  text: `The provider ${speedCode} is excluded for the selected payor.`,
  type: 'warning',
  confirmButtonText: 'Ok'
});

export const getSelectNodeAfterFilter = (agGrid: GridOptions): any[] => {
  const row = [];
  if (agGrid.api) {
    agGrid.api.forEachNodeAfterFilter((node: RowNode) => {
      if (node.isSelected()) {
        row.push(node.data);
      }
    });
  }
  return row;
};

export function getDateFormatted(date: any): Date {
  const newDate = date.month + '-' + date.day + '-' + date.year;
  return new Date(newDate);
}

export function currentDateFormatted(date: any, day?: number, month?: number, year?: number) {
  const split = date.format('MM-DD-YYYY').split('-');
  const dateFormate = {
    date: {
      day: day ? Number(split[1]) - day : split[1],
      month: month ? Number(split[0]) - month : split[0],
      year: year ? Number(split[2]) - year : split[2]
    }
  };
  return dateFormate;
}


export function mapError(error) {
  const obj = [];
  if (error && error.modelstate) {
    Object.keys(error.modelstate).forEach(
      key => { obj.push(error.modelstate[key]); }
    );
  } else if (error && error.data) {
    Object.keys(error.data).forEach(
      key => { obj.push(error.data[key]); }
    );
  }
  return obj;
}

export function formatterErrorCompany(statusCompany) {
  const detailsError = { error: 0, succes: 0, message: '' };
  if (statusCompany && statusCompany.length) {
    statusCompany.filter((item) => {
      if (item.error) {
        detailsError.message += '<p class="padding padding-t-5">' + item.error + '<p>';
      }
      if (item.changedsuccessfull || item.changesuccessfull ) {
        detailsError.succes += 1;
      } else {
        detailsError.error += 1;
      }
    });
  }
  return detailsError;
}

export function summaryCompanyAlert(summaryTrips: any, title: string, type: SweetAlertType = 'info'): Promise<SweetAlertResult> {
  return swal({
    title: title,
    html: `<div class="color-success">
            Successful Trips: <strong> ${summaryTrips.succes}</strong>
           <div>
          <div class="color-danger">
            Error Trips: <strong>${summaryTrips.error}</strong>
          <div>
          <div class="container margin-t-5 height-200 scrollbar scrollbar-small padding-b-10">
            ${summaryTrips.message}
          </div>`,
    type
  });
}

export function formatAutoAssignErrors(
  statusList: IAutoAssignStatus[]
): IAutoAssignSummary {
  const summary: IAutoAssignSummary = {
    message: '',
    total: 0,
    previouslyAssigned: 0,
    assigned: 0,
    unable: 0,
    providerAmountZero: 0,
    excludedProvider: 0
  };

  if (!statusList || !statusList.length) {
    return summary;
  }

  const summaryTrips: IAutoAssignSummary = statusList.reduce(
    (acc: IAutoAssignSummary, item) => {
      if (item && item.tripsid) {
        const count = item.tripsid.length || 0;
        acc.total += count;

        if (item.changedsuccessfull) {
          acc.assigned += count;
        } else if (item.error.includes(AutoAssignMessages.PreviouslyAssigned)) {
          acc.previouslyAssigned += count;
        } else if (item.error.includes(AutoAssignMessages.UnableToAssigned)) {
          acc.unable += count;
        } else if (item.error.includes(AutoAssignMessages.ProviderAmountZero)) {
          acc.providerAmountZero += count;
        } else if (item.error.includes(AutoAssignMessages.ExcludedProvider)) {
          acc.excludedProvider += count;
        } else {
          acc.unable += count;
        }
      } else {
        acc.total += 1;
        if (item.changedsuccessfull) {
          acc.assigned += 1;
        } else {
          acc.unable += 1;
        }
      }

      return acc;
    },
    {
      message: '',
      total: 0,
      assigned: 0,
      previouslyAssigned: 0,
      unable: 0,
      providerAmountZero: 0,
      excludedProvider: 0
    }
  );

  return summaryTrips;
}

export function showAutoAssignSummaryAlert(
  summary: IAutoAssignSummary,
  title: string,
  type: SweetAlertType = 'info'
): Promise<SweetAlertResult> {
  return swal({
    title,
    type,
    width: 450,
    showConfirmButton: true,
    html: buildSummaryHtml(summary),
  });
}

function buildSummaryHtml(summary: IAutoAssignSummary): string {
  return `
    <div class="trip-summary">
      <table class="trip-table">
        ${createRow('Total Trips', summary.total, 'row-total')}
        ${createRow('Previously Assigned', summary.previouslyAssigned, 'row-prev')}
        ${createRow('Assigned', summary.assigned, 'row-assigned')}
        ${createRow('Provider Amount Zero', summary.providerAmountZero, 'row-zero')}
        ${createRow('Unable To Assigned', summary.unable, 'row-failed')}
        ${createRow('Excluded Provider', summary.excludedProvider, 'row-failed')}
      </table>
    </div>
  `;
}

function createRow(label: string, value: number, cssClass: string): string {
  return `
    <tr class="${cssClass}">
      <td>${label}</td>
      <td class="value">${value}</td>
    </tr>
  `;
}

export function getParseJson(jsonStr: string): any {
  try {
    const obj = JSON.parse(jsonStr);
    return obj && typeof obj === 'object' ? obj : null;
  } catch (e) {
    return null;
  }
}

export function _downloadFileGenericIsExcel(blob: any, isExcel: boolean) {
  const downloadUrl = URL.createObjectURL(blob);
  isExcel
    ? window.open(window.URL.createObjectURL(blob))
    : window.open(
        downloadUrl,
        '_blank',
        'location=yes,height=700,width=520,scrollbars=yes,status=yes'
      );
}

export const getCurrentUser = () => {
  const user = localStorage.getItem('currentUser');
  return JSON.parse(user);
};

export const customKeyGenerator = (length: number) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
  }
  return result;
};

export const buildQueryString = (params): string => {
  const queryParams: string[] = [];

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const value = params[key];
      if (value !== null && value !== undefined && value !== '') {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(value);
        queryParams.push(`${encodedKey}=${encodedValue}`);
      }
    }
  }

  return queryParams.length ? '?' + queryParams.join('&') : '';
};

export const convertDecimal = (num: number, symbol: string = ''): string => {
  const decimal = 0;
  return num && isFinite(num)
    ? `${symbol} ${num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
    : `${symbol} ${decimal.toFixed(2) }`;
};

export function isValidContent(html: string): boolean {
  if (!html) {
    return false;
  }
  let text = html.replace(/<[^>]*>/g, '');
  text = text.replace(/\s|&nbsp;/g, '').trim();
  return text === '';
}

export function uniqueValues<T>(arr: T[]): T[] {
  return arr.filter((value, index, self) => self.indexOf(value) === index);
}

export function normalizeWhitespace(text: string): string {
  if (!text) {
    return '';
  }
  return text.trim().replace(/\s+/g, ' ');
}

export const EMAIL_PATTERN = '[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}';

export const PHONE_PATTERN = '\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})';

export function isValidEmail(email: string): boolean {
  if (!email) {
    return false;
  }
  const regex = new RegExp('^' + EMAIL_PATTERN + '$');
  return regex.test(email.trim());
}

export function formatName(name: IUnifiedName): string {
  if (!name) {
    return EMPTY_VALUE;
  }
  const parts = [name.firstname, name.middlename, name.lastname].filter((p) => !!p);
  return parts.join(' ') || EMPTY_VALUE;
}

export function formatDate(dateObj: IUnifiedDate | string): string {
  if (!dateObj) {
    return EMPTY_VALUE;
  }
  if (typeof dateObj === 'string') {
    const parsed = new DatePipe('en-US').transform(dateObj, 'MM/dd/yyyy');
    return parsed || dateObj;
  }
  const day = dateObj.day;
  const month = dateObj.month;
  const year = dateObj.year;
  if (!day && !month && !year) {
    return EMPTY_VALUE;
  }
  const pad = (value: string) => (value.length === 1 ? `0${value}` : value);
  if (month && day && year) {
    return `${pad(month)}/${pad(day)}/${year}`;
  }
  const parts = [month, day, year].filter((p) => !!p).map(pad);
  return parts.join('/') || EMPTY_VALUE;
}

export function formatAddress(address: IUnifiedAddress): string {
  if (!address) {
    return EMPTY_VALUE;
  }
  const parts = [address.line1, address.city, address.county, address.state, address.zip].filter((p) => !!p);
  return parts.join(', ') || EMPTY_VALUE;
}

export function formatPhone(phone: IUnifiedPhone): string {
  if (!phone) {
    return EMPTY_VALUE;
  }
  const number = phone.phonenumber || '';
  if (number.length === 10) {
    return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
  }
  return number || EMPTY_VALUE;
}



// WEBPACK FOOTER //
// ./src/app/utils/helpers.ts